// extracted by mini-css-extract-plugin
module.exports = {"page":"layout_page__ZPT7X","content":"layout_content__jhh_K","container__section":"layout_container__section__fXVxO"};